import { SERVICERS_ACTION_TYPES } from "./actionTypes";
import {
    normalizeItems,
    mergeNormalizedData,
    updateIds,
} from "../utility";

const initialState = {
    byId: {},
    allIds: [],
    items: [],

    loading: {
        list: false,
        items: {},
    },

    error: {
        list: null,
        items: {},
    },

    pagination: {
        currentPage: 1,
        totalPages: 0,
        total: 0,
        hasMore: true,
    },

    filters: {
        includeEmpty: true,
        speciality: '',
        orderBy: null,
        order: 'desc',
    },

    lastUpdated: null,
}

export const servicersReducer = (state = initialState, action) => {
    switch (action.type) {
        case SERVICERS_ACTION_TYPES.FETCH_LIST_REQUEST: {
            return {
                ...state,
                loading: {
                    ...state.loading,
                    list: true,
                },
                error: {
                    ...state.error,
                    list: null,
                }
            }
        }
        case SERVICERS_ACTION_TYPES.FETCH_LIST_SUCCESS: {
            const { data, page, total, totalPages, hasMore } = action.payload;
            const { byId: newById, allIds: newIds } = normalizeItems(data);

            const isFirstPage = page === 1;

            return {
                ...state,
                byId: isFirstPage
                    ? newById
                    : mergeNormalizedData(state.byId, newById),
                allIds: updateIds(state.allIds, newIds, isFirstPage),
                items: isFirstPage
                    ? data
                    : [ ...state.items, ...data],
                loading: {
                    ...state.loading,
                    list: false,
                },
                error: {
                    ...state.error,
                    list: null,
                },
                pagination: {
                    currentPage: page,
                    totalPages,
                    total,
                    hasMore,
                },
                lastUpdated: action.meta.timestamp,
            };
        }
        case SERVICERS_ACTION_TYPES.FETCH_LIST_FAILURE: {
            return {
                ...state,
                loading: {
                    ...state.loading,
                    list: false,
                },
                error: {
                    ...state.error,
                    list: action.payload.error,
                },
            };
        }
        default:
            return state;
    }
}